
// this utility was built for sizing the time_entry_list and tag-sidebar scroll windows on componentDidMount() and componentDidUpdate().
// if needed, this util can be refactored to size any container by passing in desired offsets into calcConainterHeight

//value (pixels from bottom) to be subtracted from window height
const FEEDBACK_BUTTON = 60

export function getInnerHeight() {
    return window.innerHeight
}

export function getTopPosition(ref) {
    return ref.getBoundingClientRect().top
}

export function calcContainerHeight(ref) {
    const windowHeight = getInnerHeight()
    const deltaTop = getTopPosition(ref)
    const deltaBottom = FEEDBACK_BUTTON

    return windowHeight - (deltaTop + deltaBottom)
}



// WEBPACK FOOTER //
// ./src/util/scroll_display_utils.js